import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';
import { Flex } from '@change-corgi/design-system-legacy/layout';

import { DecisionMaker } from './components/DecisionMaker';
import { Description } from './components/Description';
import { Media } from './components/Media';
import { Title } from './components/Title';

export function PetitionContent(): JSX.Element {
	return (
		<>
			<Text variant="heading" size="x-small" className="lowercase first-letter:uppercase" as="p">
				<Translate value="corgi.petition.edit.petition_content.heading" />
			</Text>
			<Flex sx={{ flexDirection: 'column', gap: 26 }}>
				<Title />
				<Description />
				<Media />
				<DecisionMaker />
			</Flex>
		</>
	);
}
